import React from 'react';
import classNames from 'classnames';
import './GridStyles.scss';
import { useIntl } from 'react-intl';

export default function GridBody(props) {
  const {
    columns,
    data,
    loading = false,
    emptyText = '',
    onClickByRow = () => {},
    onDoubleClickByRow = () => {},
    onContextMenu = () => {},
    rowClassFormatter = () => {},
  } = props;
  const { formatMessage } = useIntl();
  const empty = emptyText || formatMessage({ id: 'empty.data' });
  const onSelectRow = (item, index) => event => {
    onClickByRow(item, event, index);
  };
  const onDoubleSelectRow = (item, index) => event => {
    onDoubleClickByRow(item, event, index);
  };
  const onContextMenuRow = (item, index) => event => {
    onContextMenu(item, event, index);
  };
  const renderCell = (row, item, key, rowKey) => {
    let content = row[item.dataField];
    const { bodyStyle = {}, dataClassName = '' } = item;
    if (item.formatter && typeof item.formatter === 'function') {
      content = item.formatter(content, row, rowKey);
    }
    return (
      <td
        key={key}
        style={bodyStyle}
        className={classNames('data-table-cell', dataClassName)}
        onDoubleClick={e => {
          if (item.dataField === 'checkBox') e.stopPropagation();
        }}
      >
        <div className={classNames('data-table-cell-wrapper', { 'check-box-column': item.dataField === 'checkBox' })}>
          {content}
        </div>
      </td>
    );
  };

  const renderRow = (row, rowKey) => (
    <tr
      key={rowKey}
      className={classNames('data-table-row', rowClassFormatter(row, rowKey))}
      onClick={onSelectRow(row, rowKey)}
      onDoubleClick={onDoubleSelectRow(row, rowKey)}
      onContextMenu={onContextMenuRow(row, rowKey)}
    >
      {columns.map((item, key) => (renderCell(row, item, key, rowKey)))}
    </tr>
  );

  return (
    <tbody className="data-table-content">
      {data && data.map(renderRow)}
      {(!data || data.length < 1) && empty && !loading ? (<tr><td colSpan={columns.length || 0} className="text-center align-middle empty-text">{empty}</td></tr>) : null}
      {(!data || data.length < 1) && loading ? (<tr><td colSpan={columns.length || 0} className="text-center align-middle">{formatMessage({ id: 'app.loading.process' })}</td></tr>) : null}
    </tbody>
  );
}
